import { Line, Scatter } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
} from 'chart.js';
import 'chartjs-adapter-date-fns';
ChartJS.register(
    TimeScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export default function GraficaTemperatura1({datosAux = null }) {


    const noData = datosAux == null || datosAux.length == 0

    if (noData) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '20px',
                color: '#666',
                fontStyle: 'italic',
            }}>
                No hay datos de temperatura en este rango de fechas.
            </div>
        );
    }

    const chartData = {
        datasets: [{
            label: 'Temperatura (°C)',
            data: datosAux.map(item => ({
                x: item.FECHA_AGRUPADA,
                y: item.TEMPERATURA_PROMEDIO
            })),
            borderColor: '#36A2EB',
            backgroundColor: '#36A2EB',
            borderWidth: 2,
            pointRadius: 4, 
            showLine: true, 
        }],
    };

    const options = {
        scales: {
            x: {
                type: 'time',
                time: {
                    parser: "yyyy-MM-dd'T'HH:mm:ss", // Ajusta el parser al formato exacto
                    unit: 'hour',
                    stepSize: 1, // Fuerza intervalos de 1 hora
                    displayFormats: { hour: 'HH:mm' },
                    tooltipFormat: 'HH:mm',
                },
                title: { display: true, text: 'Hora del día' },
                // Fija los límites del eje X para evitar desbordamientos
                min: datosAux[0]?.x,
                max: datosAux[datosAux.length - 1]?.x,
                ticks: {
                    autoSkip: false, // Muestra todas las horas
                }
            },
            y: {
                title: { display: true, text: 'Temperatura (°C)' },
            },
        },
    };


    return <Line data={chartData} options={options} />;
}